export default class Bookmark {
  currentIndex: number = 0;
  currentIndexUid: string = '';
  score: number = 0;
  total: number = 0;
  biggestIndex: number = 0;
  lastSlideState?: unknown = {};
  version: string = '0';
  elapsedtime: string = '';
  testout?: {
    usedTestout?: boolean;
    failedTestout?: boolean;
  };

  constructor(
    currentIndex: number,
    currentIndexUid: string,
    score: number,
    total: number,
    biggestIndex: number,
    version: string,
    lastSlideState?: unknown,
    testout?: { usedTestout?: boolean; failedTestout?: boolean },
    isTestoutSession: boolean = false
  ) {
    this.currentIndex = currentIndex;
    this.currentIndexUid = currentIndexUid;
    this.score = score;
    this.total = total;
    this.version = version;
    this.lastSlideState = lastSlideState;
    this.testout = {
      ...this.testout,
      ...testout,
    };
    if (isTestoutSession)
      this.biggestIndex = biggestIndex; // Let biggestIndex be override
    else
      this.biggestIndex = biggestIndex < currentIndex ? currentIndex : biggestIndex;
  }
}
